class Dropdown {
    static classes = {
        active: 'is-active',
        wrap: 'select-input',
        header: 'select__header',
        headerPlaceholder: 'select__current',
        body: 'select__body',
        removeLabel: 'select__item-checked'
    }
    classes = Dropdown.classes;

    constructor(el) {
        this.wrap = el.closest(`.${this.classes.wrap}`);
    }

    show() {
        this.wrap.classList.add(this.classes.active);
    }

    hide() {
        this.wrap.classList.remove(this.classes.active);
    }

    static isDropdown(el) {
        return !!el.closest(`.${this.classes.wrap}`);
    }

    get isActive() {
        return this.wrap.classList.contains(this.classes.active)
    }

    get body() {
        return this.wrap.querySelector(`.${this.classes.body}`)
    }

    get header() {
        return this.wrap.querySelector(`.${this.classes.header}`)
    }

    get headerPlaceholder() {
        return this.wrap.querySelector(`.${this.classes.header} .${this.classes.headerPlaceholder}`)
    }

    get removeLabels() {
        return this.headerPlaceholder.querySelectorAll(`.${this.classes.removeLabel}`)
    }
}



export default new (class {
    constructor() {
        document.body.addEventListener('click', (e) => {
            const active = this.activeDropdownsEls;
            if (active.length) {
                active.filter(item => !item.contains(e.target)).forEach((item) => this.hide(item))
            }

            if (Dropdown.isDropdown(e.target)) {
                this.onClick(e)
            }

        })

        document.body.addEventListener('change', e => {
            if (Dropdown.isDropdown(e.target)) {
                this.onChange(e)
            }
        })
    }

    onChange(e) {
        if (e.target.type == 'checkbox') {
            this.renderCheckboxes(e.target);
        } else if (e.target.type == 'radio') {
            this.renderRadio(e.target)
        }
    }

    renderCheckboxes(el) {
        const dropdown = this.getDropdown(el);
        if (dropdown) {
            const checked = Array.from(dropdown.wrap.querySelectorAll(':checked'));
            let html = ''
            if (checked.length) {
                checked.forEach(item => {
                    html += this.renderCheckbox(item);
                })
            } else {
                html = dropdown.headerPlaceholder.dataset.placeholder;
            }

            dropdown.headerPlaceholder.innerHTML = html;

            this._checkWidth(dropdown);
        }
    }

    _checkWidth(dropdown) {
        let widthParent = dropdown.headerPlaceholder.offsetWidth - 50
        let widthChild = 0
        let countHide = 0;
        dropdown.removeLabels.forEach(item => {
            widthChild=widthChild + item.offsetWidth

            if(widthParent < widthChild) {
                item.classList.add('hide');
                countHide++
            }
        })

        if (countHide) {
            dropdown.headerPlaceholder.innerHTML += this.renderMore(countHide);
        }
    }

    renderCheckbox(el) {
        return `
        <label class="select__item-checked" for="${el.id}">
            ${el.labels[0].innerText}
            <span class="select__item-remove"></span>
        </label>`
    }

    renderMore(i) {
        return `<span class="select__item-count">+${i}</span>`
    }

    renderRadio(el) {
        const dropdown = this.getDropdown(el);
        if (dropdown) {
            const checked = dropdown.wrap.querySelector(':checked');
            let html = ''
            if (checked) {
                html = checked.labels[0].innerText;
            }
            dropdown.headerPlaceholder.innerHTML = html;
            this.hide(dropdown)
        }
    }

    onClick(e) {
        const dropdown = new Dropdown(e.target);
        if (dropdown.header.contains(e.target)) {
            this._onHeaderClick(e);
        }
    }

    _onHeaderClick(e) {
        if (e.target.closest(`.${Dropdown.classes.removeLabel}`)) return;
        const dropdown = new Dropdown(e.target);
        if (dropdown.isActive) {
            this.hide(dropdown)
        } else {
            this.show(dropdown)
        }
    }

    show(el) {
        let dropdown = this.getDropdown(el);
        if (dropdown) this._show(dropdown);
    }

    _show(dropdown) {
        if (dropdown.isActive) return;
        dropdown.show();
    }

    hide(el) {
        let dropdown = this.getDropdown(el);
        if (dropdown) this._hide(dropdown);
    }

    _hide(dropdown) {
        dropdown.hide();
    }

    get activeDropdownsEls() {
        return Array.from(document.querySelectorAll(`.${Dropdown.classes.active}`));
    }

    getDropdown(el) {
        if (!(el instanceof Dropdown)) {
            if (Dropdown.isDropdown(el)) {
                return new Dropdown(el);
            } else {
                return null;
            }
        } else {
            return el
        }
    }

    updateAll() {
        document.querySelectorAll(`.${Dropdown.classes.wrap}`).forEach(item => {
            const dropdown = new Dropdown(item);
            if (dropdown.wrap.dataset.type == 'checkbox') {
                this.renderCheckboxes(dropdown)
            } else if (dropdown.wrap.dataset.type == 'radio') {
                this.renderRadio(dropdown);
            }
        })
    }
})();
